module.exports = __webpack_public_path__ + "static/guarantee-04df4a9d305673609f24b0d9e9e6d165.png";